
// ROUTES
require('modules/feedback-category/routes/feedback-category');

// CONTROLLERS
require('modules/feedback-category/controllers/feedback-category');
require('modules/feedback-category/controllers/list');
require('modules/feedback-category/controllers/create');
require('modules/feedback-category/controllers/edit');

// SERVICES
require('modules/feedback-category/services/feedback-category');
require('modules/feedback-category/services/list');
require('modules/feedback-category/services/create');
require('modules/feedback-category/services/edit');
require('modules/feedback-category/services/delete');



angular.module('unica_feedback_category', [

	// ROUTES
	'unica_feedback_category.feedback_category_routes',

	// CONTROLLERS
	'unica_feedback_category.feedback_category_controllers',

	// SERVICES
	'unica_feedback_category.feedback_category_services'

]);